import React, { Component } from 'react';
import { Provider } from 'react-redux';
import { StyleSheetManager } from 'styled-components';
import isPropValid from '@emotion/is-prop-valid';
import store from './store';
import { loadReCaptcha } from './common/reCaptcha';
import RouterComponent from './routing/RouterComponent';
import { setLogoutHandler } from './axiosInstance';
import { userActions, notifyActions } from './store/actions';

// se anche la refreshToken fallisce, forzo il logout e svuoto lo store
setLogoutHandler(() => {
  store.dispatch(userActions.logoutRequest());
  store.dispatch(notifyActions.warningAction('Sessione scaduta, effettua di nuovo il login'));
});

/**
 * styled-components v6 non filtra più le props non HTML: senza questo filtro le opzioni delle colonne
 * di react-data-table-component (allowOverflow, button, right, minWidth...) finiscono sui div e React genera dei warning.
 */
const shouldForwardProp = (propName, target) => typeof target === 'string' ? isPropValid(propName) : true;

export default class App extends Component {

  componentDidMount() {
    loadReCaptcha();
  }

  render() {
    return (
      <Provider store={store}>
        <StyleSheetManager shouldForwardProp={shouldForwardProp}>
          <div className="appContainer">
            <RouterComponent />
          </div>
        </StyleSheetManager>
      </Provider>
    );
  }
}
